import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaBancosLayout', {
    template: template,
    controller: NominasNominaBancosLayoutComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
    },
  })

function NominasNominaBancosLayoutComponent(NominasNominaLayoutbancario, NominasNomina, $file) {
  let $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.generarBancomer = generarBancomer
  $ctrl.generarSantander = generarSantander

  function $onInit() {
    $ctrl.idBanco = '005'
    $ctrl.data = undefined

    return NominasNominaLayoutbancario.get($ctrl.idEmpresa, $ctrl.idNomina)
      .then(function (list) {
        function filtrar(idBanco) {
          return list.filter(function (item) {
            return item.ID_Banco == idBanco
          })
        }

        $ctrl.data = {
          '005': filtrar('005'),
          '012': filtrar('012'),
        }
      })
  }

  function generarBancomer($data) {
    return NominasNominaLayoutbancario.bancomer($data, $ctrl.idNomina)
      .then(function (file) {
        return $file.saveAs(file)
      })
  }

  function generarSantander($data) {
    let cuentaCargo = prompt('Especifique la cuenta de cargo')

    if (cuentaCargo)
      return NominasNomina.get($ctrl.idEmpresa, $ctrl.idNomina)
        .then(function (nomina) {
          return NominasNominaLayoutbancario.santander($data, $ctrl.idNomina, {
              fechaPago: nomina.Fecha_Pago,
              cuentaCargo: cuentaCargo,
            })
            .then(function (file) {
              return $file.saveAs(file)
            })
        })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/bancos/layout/component.js